export default __webpack_public_path__ + "static/media/2.bcaff27a.png";